import {
  BooleanOperator,
  ConditionTab,
  ConditionType,
  DatetimeOperator,
  FrequencyOperator,
  ListOperator,
  NumberOperator,
  StringOperator,
  Type,
} from './enums/builder-enums';
import {Property, WindowUnit} from './enums/expression-enums';
import {FilterOperator} from './types/builder-state-types';

export const CONDITION_TYPE_TO_TAB_MAPPING = {
  [ConditionType.Cohorts]: ConditionTab.Cohorts,
  [ConditionType.Events]: ConditionTab.Events,
  [ConditionType.People]: ConditionTab.People,
};

export const LITERAL_NAMES = [
  `A`,
  `B`,
  `C`,
  `D`,
  `E`,
  `F`,
  `G`,
  `H`,
  `I`,
  `J`,
  `K`,
  `L`,
  `M`,
  `N`,
  `O`,
  `P`,
  `Q`,
  `R`,
  `S`,
  `T`,
  `U`,
  `V`,
  `W`,
  `X`,
  `Y`,
  `Z`,
];
export const MAX_LITERALS = LITERAL_NAMES.length;
export const MAX_CONDITIONS = 15;
export const LITERAL_NAME_REGEX = new RegExp(`[${LITERAL_NAMES.join(``)}]\\d*`, `g`);

export const DEFAULT_FREQUENCY_VALUE = 1;
export const ANY_EVENT = ``;
export const FIRST_EVENT = `$first_event`;
export const DEFAULT_EVENT = ANY_EVENT;

export const DEFAULT_RELATIVE_NUM_DAYS = 7;
export const DEFAULT_WINDOW_UNIT = WindowUnit.Day;

export const DEFAULT_PEOPLE_PROPERTY_OPTIONS = {
  operator: DatetimeOperator.Relative,
  property: `$created`,
  propertyType: Property.User,
  type: Type.Datetime,
  value: {
    window: {
      unit: WindowUnit.Day,
      value: 30,
    },
  },
};
export const MAX_LABEL_ENTRIES = 3;
export const SHOW_MORE_LIMIT = 5;
export const TABS_LIMIT_NORMAL_WIDTH = 4;
export const MAX_COHORT_NAME_LENGTH = 190;
export const FUNNEL_CLAUSE_OPERATOR: any = null;

export const FREQUENCY_OPERATOR_LIST = [
  FrequencyOperator.Between,
  FrequencyOperator.AtLeast,
  FrequencyOperator.GreaterThan,
  FrequencyOperator.LessThan,
  FrequencyOperator.EqualTo,
];

export const FILTER_TYPE_LIST = [Type.String, Type.Number, Type.Boolean, Type.Datetime, Type.List];

const STRING_FILTER_OPERATOR_LIST = [
  StringOperator.Contains,
  StringOperator.DoesNotContain,
  StringOperator.Equals,
  StringOperator.DoesNotEqual,
  StringOperator.Set,
  StringOperator.NotSet,
];

const NUMBER_FILTER_OPERATOR_LIST = [
  NumberOperator.Between,
  NumberOperator.AtLeast,
  NumberOperator.GreaterThan,
  NumberOperator.LessThan,
  NumberOperator.EqualTo,
  NumberOperator.NotEqualTo,
];

const DATETIME_FILTER_OPERATOR_LIST = [
  DatetimeOperator.Between,
  DatetimeOperator.After,
  DatetimeOperator.On,
  DatetimeOperator.RelativeBeforeInPast,
  DatetimeOperator.Relative,
  DatetimeOperator.RelativeFuture,
];

export const FILTER_OPERATORS: {[filter: string]: FilterOperator[]} = {
  [Type.String]: STRING_FILTER_OPERATOR_LIST,
  [Type.Number]: NUMBER_FILTER_OPERATOR_LIST,
  [Type.Datetime]: DATETIME_FILTER_OPERATOR_LIST,
  [Type.Boolean]: [BooleanOperator.True, BooleanOperator.False],
  [Type.List]: [ListOperator.Contains, ListOperator.DoesNotContain],
};

export const DEFAULT_FILTER_OPERATOR: {[filter: string]: FilterOperator} = {
  [Type.String]: StringOperator.Equals,
  [Type.Number]: NumberOperator.EqualTo,
  [Type.Datetime]: DatetimeOperator.Relative,
  [Type.Boolean]: BooleanOperator.True,
  [Type.List]: ListOperator.Contains,
};
